import { Component, OnInit } from '@angular/core';
import { ciInterface } from 'src/app/util/interfaces/ci';
import { CmdbPrintQrcodeService } from './service/cmdb-print-qrcode.service';
import { faTimes, faWrench, faPrint } from '@fortawesome/free-solid-svg-icons';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'app-cmdb-print-qrcode',
	templateUrl: './cmdb-print-qrcode.component.html',
	styleUrls: ['./cmdb-print-qrcode.component.scss'],
})
export class CmdbPrintQrcodeComponent implements OnInit {
	icons = {
		faWrench: faWrench,
		faTimes: faTimes,
		faPrint: faPrint,
	};

	labels: LabelsInterface = {
		lbl_geral_sim: 'Yes',
		lbl_geral_nao: 'No',
		lbl_geral_identificacao: '',
		lbl_geral_informacoes: '',
		lbl_geral_qrcode: '',
		lbl_geral_colunas: '',
		lbl_geral_imprimir: '',
		lbl_geral_fechar: '',
	};

	constructor(
		private CmdbPrintQrcodeService: CmdbPrintQrcodeService,
		private LabelsService: LabelsService
	) {}

	type: 'barcode' | 'qrcode' = null;

	cisWithQrCode: ciInterface['ciArray'][number][] = [];
	isLoadingQrCodes = false;
	isLoadingLabels = false;

	isConfigOpen = false;
	columns = 4;
	showId = 1;
	showName = 1;
	showQrCodeDecode = 1;

	ngOnInit(): void {
		this.type = <any>location.href.split('/')[location.href.split('/').length - 1];
		if (this.type === 'barcode') this.columns = 3;

		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});
		this.getAllQrCodes();
	}

	getAllQrCodes(): void {
		this.isLoadingQrCodes = true;
		if (this.type === 'qrcode') {
			this.CmdbPrintQrcodeService.getAllQrCodes(this.type).subscribe((qrCodes) => {
				for (const qrCode of qrCodes.hasQR) {
					const newCi: ciInterface['ciArray'][number] = {
						cmdb_id: qrCode.id,
						id: qrCode.id,
						identification: qrCode.identification,
						type: 'N/A',
						qrCode: qrCode.qrCode,
					};
					this.cisWithQrCode.push(newCi);
				}

				this.isLoadingQrCodes = false;
			});
		} else if (this.type === 'barcode') {
			this.CmdbPrintQrcodeService.getAllQrCodes(this.type).subscribe((barCodes) => {
				for (const barCode of barCodes.hasBar) {
					const newCi: ciInterface['ciArray'][number] = {
						cmdb_id: barCode.id,
						id: barCode.id,
						identification: barCode.identification,
						type: 'N/A',
						barCode: barCode.barCode,
					};
					this.cisWithQrCode.push(newCi);
				}

				this.isLoadingQrCodes = false;
			});
		}
	}

	print(): void {
		window.print();
	}
}
